export default __webpack_public_path__ + "static/media/keto_monitor_health.1c503d06.jpg";